import { Box, Typography } from "@mui/material";

interface Props {
  text: string;
}

const RunPreview = ({ text }: Props) => (
  <Box sx={{ bgcolor: "background.grey", borderRadius: 1, px: 1.5, py: 1 }}>
    <Typography sx={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>{text}</Typography>
  </Box>
);

export default RunPreview;
